import {
  inventoryManagementServiceStores,
  getInventoryManagementHostServiceStores,
} from "@intrasync/inventory-management";
import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Inventory Module Service Stores — @intrasync/inventory-management
 *
 * The module ships its own domain service-store configs (all `inventory-*`
 * service paths) plus a list of host-owned services it reads from. Host
 * services already registered elsewhere in serviceStoresConfig (crm.stores:
 * customers/vendors, user.stores: users, organization-data.stores: projects)
 * are filtered out here so they aren't mounted twice.
 */
const HOST_STORES_REGISTERED_ELSEWHERE = new Set<string>([
  "users",
  "vendors",
  "customers",
  "projects",
]);

export const inventoryStores: ServiceStoreConfig[] = [
  ...inventoryManagementServiceStores,
  ...getInventoryManagementHostServiceStores().filter(
    (config) => !HOST_STORES_REGISTERED_ELSEWHERE.has(config.name)
  ),
] as unknown as ServiceStoreConfig[];
